import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import {SlideDown} from 'react-slidedown'
import Loader from 'react-loader'
import * as searchActions from 'redux/modules/search'
import {
  // Link,
  LinkIcon,
  CompanyProfileModal,
} from '../'
import Styles from './ScreenedCompanies.css'

@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)

@CSSModules(Styles, {allowMultiple: true})
export default class ScreenedCompanies extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
    // search: PropTypes.func,
  }
  constructor(props){
    super(props)
    this.state = {
      mmcViewMore: false,
      nwViewMore: false,
      cmViewMore: false,
      mmcCompanies: [],
      nwCompanies: [],
      cmCompanies: [],
    }
  }
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.props.companies()
  }

  componentWillReceiveProps(props){
    if (props.result) {
      let mmcCompanies = []
      let nwCompanies = []
      let cmCompanies = []
      props.result.map((el)=>{
        if (el.is_mmc) mmcCompanies.push(el)
        if (el.is_nw) nwCompanies.push(el)
        if (el.is_cm) cmCompanies.push(el)
        return false
      })
      const _sorter = (a, b)=>{
        const lbl = 'short_name'
        const a_s = a[lbl].toLowerCase()
        const b_s = b[lbl].toLowerCase()
        return a_s.localeCompare(b_s)
      }
      mmcCompanies = mmcCompanies.sort(_sorter)
      nwCompanies = nwCompanies.sort(_sorter)
      cmCompanies = cmCompanies.sort(_sorter)
      this.setState({
        mmcCompanies,
        nwCompanies,
        cmCompanies,
      })
    }
  }

  clickViewMore = (lbl) =>{
    const stateLbl = lbl + 'ViewMore'
    const newState = {}
    newState[stateLbl] = !this.state[stateLbl]
    this.setState(newState)
  }

  renderButton = (lbl) => {
    const viewMore = this.state[lbl + 'ViewMore']
    const companies = this.state[lbl + 'Companies']
    return (
      <div>
        <button
          styleName='company-table-button'
          onClick={()=>{
            if (this.state.mmcCompanies.length) {
              this.clickViewMore(lbl)
            }
          }}
          title='View companies'
        >
          { this.state.mmcCompanies.length ?
              <span>
                View companies
                <LinkIcon
                  faclass={(viewMore)?'fa-angle-up':'fa-angle-down'}
                />
              </span> :
              <Loader
                options={{
                  scale: 0.70,
                  position: 'relative',
                  top: '50%',
                  zIndex: '10000'
                }}
                loaded={false}
              />
          }
        </button>
        <SlideDown>
          { viewMore ?
              <table styleName='t-table'>
                <thead>
                  <tr>
                    <th>Company</th>
                    <th>Symbol</th>
                    <th>Legal name</th>
                  </tr>
                </thead>
                <tbody>
                  { companies.map((c, i)=>{
                    return (
                      <tr key={'to_'+i}>
                        <td><CompanyProfileModal holding={c}><b>{c.short_name}</b></CompanyProfileModal></td>
                        <td>{c.primary_symbol}</td>
                        <td>{c.legal_name}</td>
                      </tr>
                    )
                  }) }
                </tbody>
              </table> : null
          }
        </SlideDown>
      </div>
    )
  }

  render() {
    const icons = {
      mmc: require( '../../../static/images/icn-mmc-active-black.svg' ),
      nw: require( '../../../static/images/icn-nw-active-black.svg' ),
      cm: require( '../../../static/images/icn-cm-active-black.svg' ),
    }

    return (
      <div styleName='main-wrap'>
        { /* <div styleName='answer-title'>Military weapons</div> */ }

        <div styleName='screen-card'>
          <img
            styleName='screen-icon'
            alt='Military contractors'
            src={icons.mmc}
          />
          <div styleName='screen-icon-label'>
            <p>
              <strong>Military contractors</strong> &mdash; Arms manufacturers and military contractors fuel global warfare through the international arms trade. Concerns about social impact, human rights, reputation risk, and regulatory risks are just a few of the reasons companies like these are avoided by sustainable investors.
            </p>

            {this.renderButton('mmc')}

          </div>
        </div>

        <div styleName='screen-card'>
          <img
            styleName='screen-icon'
            alt='Nuclear weapons'
            src={icons.nw}
          />
          <div styleName='screen-icon-label'>
            <p>
              <strong>Nuclear weapons</strong> &mdash;  The financing of companies contributing to the build-up and modernization of nuclear arms undermines efforts to achieve nuclear disarmament. Any use of nuclear weapons would violate fundamental rules of international law and have catastrophic humanitarian and environmental consequences.
            </p>

            {this.renderButton('nw')}

          </div>
        </div>

        <div styleName='screen-card'>
          <img
            styleName='screen-icon'
            alt='Controversial weapons'
            src={icons.cm}
          />
          <div styleName='screen-icon-label'>
            <p>
              <strong>Controversial weapons</strong> &mdash; Weapons like
              cluster munititions, anti-personnel landmines, incendiary
              weapons, and depleted uranium are considered particularly
              controversial because of their indiscriminate impacts.
              Unexploded cluster bomblets and landmines kill and maim
              civilians for years after conflicts end. The use of
              depleted uranium ammunition
              is linked to increased cancer rates and birth deformities.
              These weapons are banned by hundreds of countries under
              various treaties.
            </p>

            {this.renderButton('cm')}

          </div>
        </div>

      </div>
    )
  }
}

